import { useState } from "react";
import useDocumentTitle from "../../utils/useDocumentTitle";

import ClassNames from "classnames";
import { Link, useHistory } from "react-router-dom";
import Button from "../../components/Button";
import TextField from "../../components/TextField";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import styles from "./Login.module.scss";


import FlashCoachLogo from "../../components/_Icons/FlashCoachLogo";
import TDCXLogo from "../../components/_Icons/TDCXLogo";

export function ForgotPassword(props) {
  useDocumentTitle(props.title);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { addNotification } = useNotification();

  const [email, setEmail] = useState();

  const handleSubmit = async () => {
    if (!isEmailValid(email)) {
      addNotification("Invalid email address", "error");
      return;
    }
    setIsLoading(true);
    try {
      const response = await apiRequest.post(`/api/forgotPassword`, {
        email: email,
      });
      let data = response.data;

      if (data.error) {
        addNotification(data.error, "error");
        setIsLoading(false);
        return;
      }
      // if email success (status != "fail")
      if (!(data.status && data.status === "fail")) {
        addNotification(
          "Instructions on how to reset password have been sent to your email",
          "success"
        );
        history.push("/");
      } else if (data.status === "fail") {
        addNotification(data.msg, "error");
        setIsLoading(false);
      }
    } catch (error) {
      addNotification("something went wrong, please try again", "error");
      setIsLoading(false);
    }
  };

  const isEmailValid = val => {
    let regEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regEmail.test(val)) {
      return false;
    }
    return true;
  };

  return (
    <form onSubmit={(e) => {
      e.preventDefault(); handleSubmit()
    }}>
      <div className={styles.pageWrapper}>
        <div className={styles.loginBlock}>
          <div className={styles.logo}>
            <FlashCoachLogo />
          </div>
          <div className={styles.loginContent}>
            <div className={styles.loginContent__formControl}>
              <TextField
                variant="outlined"
                fullWidth
                label="Email"
                type="text"
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                }}
                autoComplete="email"
              />
            </div>
            <div
              className={ClassNames(
                styles.loginContent__formControl,
                styles.loginContent__actions
              )}
            >
              {/* TODO: link to forgot password page */}
              <div className={styles.right}>
                <Link className={styles.loginForm__forgotPassword} to="/">
                  Back to Login
                </Link>
              </div>
            </div>
            <div
              className={ClassNames(
                styles.loginContent__formControl,
                styles.loginContent__submitBtnWrapper
              )}
            >
              <Button
                type="submit"
                color="primary"
                style={{ backgroundColor: "#f5b019" }}
                variant="contained"
                fullWidth
                isloading={isLoading ? 1 : 0}
              >
                {"Get new password"}
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.logo}>
            <TDCXLogo width={100} />
          </div>
          <div className={styles.copyright}>
            Copyright © 2021 TDCX. All Rights Reserved.
          </div>
        </div>
      </div>
    </form>
  );
}
